module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "annual-fees-media.0d110a79.jpg" + "?" + Date.now();